module.exports = __webpack_public_path__ + "img/coin3.d226c35e.png";